import { Button, DialogContent, Grid, Typography } from '@mui/material'

import DialogWithTitle from '../dialog-with-title'

interface DeviceChangeSolutionModalProps {
  open: boolean
  onCancel: () => void
  onContinue: () => Promise<void>
}

const DeviceChangeSolutionModal = ({ open, onCancel, onContinue }: DeviceChangeSolutionModalProps) => (
  <DialogWithTitle open={open} title="Change Solution" setOpen={onCancel}>
    <DialogContent sx={{ maxWidth: '400px' }}>
      <Typography>Updating the solution will resolve and clear any currently active alerts linked to the previous solution on this device.</Typography>
      <Grid
        container={true}
        size={12}
        sx={{
          justifyContent: 'flex-end',
          gap: 2,
          marginTop: 3,
        }}
      >
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onContinue}>
          Change Solution
        </Button>
      </Grid>
    </DialogContent>
  </DialogWithTitle>
)

export default DeviceChangeSolutionModal
